module.exports = __webpack_public_path__ + "static/media/LogoFarming.1605e8ed.png";